import React from 'react'
import PresenterSection from '../../sections/PresenterSection'
import { PresenterSliceProps } from './types'

const PresenterSlice: React.FC<PresenterSliceProps> = ({ slice }) => {
  const { p_title, p_description, p_photo, p_background_image } = slice.primary || {}

  return (
    <PresenterSection
      headingPadding={['60px', '', '130px']}
      inner="inners.primary"
      paddingTop={['38px', '', '90px']}
      paddingBottom={['0', '', '100px']}
      data={{
        photo: {
          image: {
            publicURL: p_photo?.url,
            childImageSharp: p_photo && {
              gatsbyImageData: p_photo.gatsbyImageData
            },
            width: p_photo?.dimensions?.width,
            height: p_photo?.dimensions?.height,
            alt: p_photo?.alt || ''
          }
        },
        backgroundImage: {
          image: {
            publicURL: p_background_image?.url,
            childImageSharp: p_background_image && {
              gatsbyImageData: p_background_image.gatsbyImageData
            },
            width: p_background_image?.dimensions?.width,
            height: p_background_image?.dimensions?.height,
            alt: p_background_image?.alt || ''
          }
        },
        name: p_title?.text || '',
        description: p_description?.html || ''
      }}
    />
  )
}

export default PresenterSlice
